import $dayjs from '@/services/date'

/**
 * Determines whether the month component of a date to be presented should
 * proceed the day component for a specified locale.
 *
 * @param locale The locale to check
 * @returns {Boolean}
 */
const isMonthBeforeDay = (locale) => {
  return (
    $dayjs()
      .locale(locale.toLowerCase())
      .localeData()
      .longDateFormat('L') === 'MM/DD/YYYY'
  )
}

/**
 * Helps with sorting Dates by providing a difference in time between
 * two Dates expressed in milliseconds.
 *
 * @param {Date} firstDate
 * @param {Date} secondDate
 * @returns {Number}
 */
const sortDate = (firstDate, secondDate) =>
  $dayjs(firstDate).diff($dayjs(secondDate))

export { isMonthBeforeDay, sortDate }
